import React from 'react'
import { Row, Col, Label } from 'reactstrap'
import { Button } from '@/components/button'
import { DropDownList } from '@/components/dropDownList'

const formatProviderName = (props, x) => props.localize(`Security.TwoFactorProvider_${x.providerName}`) + (x.contact ? ` ( ${x.contact} )` : '')
const PreferredMethodSelector = (props) => {
  const { updateProvider } = props
  const [preferredProvider, setPreferredProvider] = React.useState(props.twoFactor.preferredTwoFactorProvider.providerName)
  const handleChange = React.useCallback((x) => setPreferredProvider(x.value), [])
  const handleOnClick = React.useCallback(() => updateProvider({ providerName: preferredProvider }), [preferredProvider, updateProvider])
  const data = props.twoFactor.availableTwoFactorProviders.map(x => ({ providerName: x.providerName, text: formatProviderName(props, x) }))

  const loading = props.providerUpdating
  const disabledButton = props.twoFactor.preferredTwoFactorProvider.providerName === preferredProvider || loading
  return (
    <React.Fragment>
      <Row><Col><hr /></Col></Row>
      <Row><Col><Label>{props.localize('Security.PreferredTwoFactorProvider')}</Label></Col></Row>
      <Row>
        <Col sm='6'>
          <Label>{props.localize('Security.CurrentProvider')}</Label>
          <div>{formatProviderName(props, props.twoFactor.preferredTwoFactorProvider)}</div>
        </Col>
        <Col sm='6'>
          <Label>{props.localize('Security.ChangePreferredProvider')}</Label>
          <DropDownList
            textField='text'
            valueField='providerName'
            data={data}
            value={preferredProvider}
            onChange={handleChange}
            allowClear={false} />
          <Button
            color='primary'
            icon={loading ? 'loader bx-spin' : 'key'}
            onClick={handleOnClick}
            disabled={disabledButton}>
            {props.localize('Security.ChangeProvider')}
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export {
  PreferredMethodSelector
}



// WEBPACK FOOTER //
// ./src/dialogs/twoFactorSetup/preferredMethodSelector.js